export default {"src":"/_next/static/media/mental-health-matters.d8905b0d.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};